import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "antd";
export default function OffsetDateTimePicker({ value = null, onChange = undefined, showTime = true, allowClear = true, disabled = false, format = "DD-MM-YYYY HH:mm", placeholder = "Date / Time", disabledDate, presets }) {
    function emitOnChange(dayjs) {
        if (dayjs && onChange) {
            onChange(dayjs.toISOString());
        }
        else if (onChange) {
            onChange(null);
        }
    }
    return (_jsx(DatePicker, { value: value ? dayjs(value) : null, onChange: emitOnChange, showTime: showTime, allowClear: allowClear, disabled: disabled, format: format, placeholder: placeholder, disabledDate: disabledDate, presets: presets }));
}
